import React from 'react';
import { connect } from 'react-redux';

import { HtmlContent } from '@dndbeyond/character-components/es';
import {
    rulesEngineSelectors,
    AbilityLookup,
    Background,
    BackgroundUtils,
    DataOriginRefData,
    SnippetData,
    RuleData,
    RuleDataUtils,
    CharacterTheme,
} from '@dndbeyond/character-rules-engine/es';

import { FeatureSnippetChoices } from '../../../../CharacterSheet/components/FeatureSnippet';
import { SidebarHeader, SidebarSubheading } from '../../../components/Sidebar';
import { SharedAppState } from '../../../stores/typings';

interface Props {
    background: Background;
    abilityLookup: AbilityLookup;
    ruleData: RuleData;
    snippetData: SnippetData;
    dataOriginRefData: DataOriginRefData;
    proficiencyBonus: number;
    theme: CharacterTheme;
}
class BackgroundPane extends React.PureComponent<Props> {
    render() {
        const { background, ruleData, abilityLookup, snippetData, dataOriginRefData, proficiencyBonus, theme } =
            this.props;

        if (!background) {
            return null;
        }

        const choices = BackgroundUtils.getChoices(background);
        const hasCustomBackground = BackgroundUtils.getHasCustomBackground(background);
        const description = BackgroundUtils.getDescription(background);
        const name = BackgroundUtils.getName(background);
        const featureName = BackgroundUtils.getFeatureName(background);
        const featureDescription = BackgroundUtils.getFeatureDescription(background);

        const sourceDataLookup = RuleDataUtils.getSourceDataLookup(ruleData);

        return (
            <div className="ct-background-pane">
                <SidebarHeader>{name}</SidebarHeader>
                <div className="ct-background-pane__data">
                    <div
                        className="ct-background-pane__data-choices"
                        style={theme.isDarkMode ? { borderColor: theme.themeColor } : undefined}
                    >
                        <FeatureSnippetChoices
                            choices={choices}
                            ruleData={ruleData}
                            abilityLookup={abilityLookup}
                            snippetData={snippetData}
                            sourceDataLookup={sourceDataLookup}
                            dataOriginRefData={dataOriginRefData}
                            proficiencyBonus={proficiencyBonus}
                            theme={theme}
                        />
                    </div>
                </div>
                {hasCustomBackground ? (
                    <div className="ct-background-pane__description ct-background-pane__description--custom">
                        {description}
                    </div>
                ) : (
                    <HtmlContent className="ct-background-pane__description" html={description ? description : ''} />
                )}
                {hasCustomBackground && featureName && (
                    <div className="ct-background-pane__feature">
                        <div className="ct-background-pane__feature-name">
                            <SidebarSubheading>Feature: {featureName}</SidebarSubheading>
                        </div>
                        <HtmlContent
                            className="ct-background-pane__feature-description"
                            html={featureDescription ? featureDescription : ''}
                        />
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        ruleData: rulesEngineSelectors.getRuleData(state),
        abilityLookup: rulesEngineSelectors.getAbilityLookup(state),
        background: rulesEngineSelectors.getBackgroundInfo(state),
        snippetData: rulesEngineSelectors.getSnippetData(state),
        dataOriginRefData: rulesEngineSelectors.getDataOriginRefData(state),
        proficiencyBonus: rulesEngineSelectors.getProficiencyBonus(state),
    };
}

export default connect(mapStateToProps)(BackgroundPane);
